/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOptionsQuery
 */
export interface GetOptionsQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOptionsQuery
     */
    keys?: Array<string> | null;
}

export function GetOptionsQueryFromJSON(json: any): GetOptionsQuery {
    return GetOptionsQueryFromJSONTyped(json, false);
}

export function GetOptionsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOptionsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'keys': !exists(json, 'keys') ? undefined : json['keys'],
    };
}

export function GetOptionsQueryToJSON(value?: GetOptionsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'keys': value.keys,
    };
}


